export default __webpack_public_path__ + "static/media/showData1.9be22f00.png";